import {defineMessage} from 'react-intl';
import html from './html/html';
import success from './html/success';
import cancel from './html/cancel';
import htmlSteps from './html/steps';
import react from './react/index';
import reactSteps from './react/steps';
import node, {steps as nodeSteps} from './server/node';
import ruby, {steps as rubySteps} from './server/ruby';
import python, {steps as pythonSteps} from './server/python';
import php, {steps as phpSteps} from './server/php';
import java, {steps as javaSteps} from './server/java';
import go, {steps as goSteps} from './server/go';
import dotnet, {steps as dotnetSteps} from './server/dotnet';
import docs from './build';
import nextSteps, {serverSteps as nextServerSteps} from './next.js/steps';
import {pageIndex, checkoutIndex, dotenv} from './next.js';

export const sections = [
  {
    id: 'setup-stripe',
    heading: {
      message: defineMessage({
        id: 'docsApp.ib.checkout.sections.setup-stripe',
        defaultMessage: 'Set up the server',
      }),
    },
    active: true,
  },
  {
    id: 'build-page',
    heading: {
      message: defineMessage({
        id: 'docsApp.ib.checkout.sections.build-page',
        defaultMessage: 'Build your checkout',
      }),
    },
  },
  {
    id: 'testing',
    heading: {
      message: defineMessage({
        id: 'docsApp.ib.checkout.sections.testing',
        defaultMessage: 'Test your page',
      }),
    },
  },
];

export const integrations = {
  docs,
  html: {
    steps: htmlSteps,
    files: {
      html: {
        builder: html,
        language: 'html',
        name: 'public/checkout.html',
      },
      success: {
        builder: success,
        language: 'html',
        name: 'public/success.html',
      },
      cancel: {builder: cancel, language: 'html', name: 'public/cancel.html'},
    },
  },
  react: {
    steps: reactSteps,
    files: {
      react: {
        builder: react,
        language: 'jsx',
        name: 'src/App.js',
      },
    },
  },
  next: {
    steps: nextSteps,
    files: {
      'pages/index.js': {
        builder: pageIndex,
        language: 'jsx',
        name: 'pages/index.js',
        label: 'pages/index.js',
      },
      '.env': {
        builder: dotenv,
        language: 'shell',
        name: '.env',
      },
    },
  },
  nextServer: {
    steps: nextServerSteps,
    files: {
      'pages/api/checkout_sessions.js': {
        builder: checkoutIndex,
        language: 'jsx',
        name: 'pages/api/checkout_sessions.js',
        label: 'pages/api/checkout_sessions.js',
      },
    },
  },
  node: {
    files: {
      node: {
        builder: node,
        language: 'js',
        name: 'server.js',
      },
    },
    steps: nodeSteps,
  },
  ruby: {
    files: {
      ruby: {
        builder: ruby,
        language: 'ruby',
        name: 'server.rb',
      },
    },
    steps: rubySteps,
  },
  python: {
    files: {
      python: {
        builder: python,
        language: 'python',
        name: 'server.py',
      },
    },
    steps: pythonSteps,
  },
  php: {
    files: {
      php: {
        builder: php,
        language: 'php',
        name: 'create-checkout-session.php',
      },
    },
    steps: phpSteps,
  },
  java: {
    files: {
      java: {
        builder: java,
        language: 'java',
        name: 'Server.java',
      },
    },
    steps: javaSteps,
  },
  go: {
    files: {
      go: {
        builder: go,
        language: 'go',
        name: 'Server.go',
      },
    },
    steps: goSteps,
  },
  dotnet: {
    files: {
      dotnet: {
        builder: dotnet,
        language: 'dotnet',
        name: 'Server.cs',
      },
    },
    steps: dotnetSteps,
  },
};

export default {
  integrations,
  sections,
};
